// ============================================================================
// Quest System Types
// ============================================================================
// Quest type identifiers
export const QuestType = {
    GATHER_WOOD: 2,
    BUILD_CRAFTING_TABLE: 7,
    CRAFT_AXE: 8,
    CRAFT_FISHING_ROD: 9,
    GATHER_FOOD: 10,
    CRAFT_WEAPON: 4,
    KILL_WOLF: 5,
    BUILD_WALLS: 6,
};
// Quest reward types
export const QuestRewardType = {
    ITEMS: 0,
    SKILL_XP: 1,
    SPAWN_PAWN: 2,
};
// Item type constants for rewards (numeric literals to avoid circular imports with ItemType)
const ITEM_STONE_PICKAXE = 311;
const ITEM_COOKED_MEAT = 202;
const ITEM_IRON_ORE = 3;
const ITEM_COPPER_ORE = 5;
const ITEM_COOKED_SALMON = 212;
const ITEM_WOODEN_BOW = 500;
const ITEM_WOODEN_ARROW = 550;
const ITEM_IRON_SWORD = 402;
const ITEM_IRON_BAR = 101;
// Starter quest definitions
export const STARTER_QUESTS = [
    {
        type: QuestType.GATHER_WOOD,
        name: 'Gather Wood',
        description: 'Harvest 30 wood from trees',
        targetAmount: 30,
        icon: 'wood',
        prerequisites: [],
        rewards: [
            { type: QuestRewardType.ITEMS, items: [{ itemType: ITEM_STONE_PICKAXE, quantity: 1 }] },
        ],
    },
    {
        type: QuestType.BUILD_CRAFTING_TABLE,
        name: 'Build a Crafting Table',
        description: 'Construct a crafting table',
        targetAmount: 1,
        icon: 'crafting_table',
        prerequisites: [QuestType.GATHER_WOOD],
        rewards: [
            { type: QuestRewardType.ITEMS, items: [{ itemType: ITEM_COOKED_MEAT, quantity: 10 }] },
        ],
    },
    {
        type: QuestType.CRAFT_AXE,
        name: 'Craft an Axe',
        description: 'Craft an axe at a crafting table',
        targetAmount: 1,
        icon: 'axe',
        prerequisites: [QuestType.BUILD_CRAFTING_TABLE],
        rewards: [
            {
                type: QuestRewardType.ITEMS,
                items: [
                    { itemType: ITEM_IRON_ORE, quantity: 5 },
                    { itemType: ITEM_COPPER_ORE, quantity: 5 },
                ],
            },
        ],
    },
    {
        type: QuestType.CRAFT_FISHING_ROD,
        name: 'Craft a Fishing Rod',
        description: 'Craft a fishing rod at a crafting table',
        targetAmount: 1,
        icon: 'fishing_rod',
        prerequisites: [QuestType.BUILD_CRAFTING_TABLE],
        rewards: [
            { type: QuestRewardType.SKILL_XP, skillId: 'fishing', xp: 500 },
            { type: QuestRewardType.ITEMS, items: [{ itemType: ITEM_COOKED_SALMON, quantity: 5 }] },
        ],
    },
    {
        type: QuestType.GATHER_FOOD,
        name: 'Gather Food',
        description: 'Gather 30 food from fishing or foraging',
        targetAmount: 30,
        icon: 'food',
        prerequisites: [QuestType.BUILD_CRAFTING_TABLE],
        rewards: [
            { type: QuestRewardType.SKILL_XP, skillId: 'cooking', xp: 500 },
            { type: QuestRewardType.ITEMS, items: [{ itemType: ITEM_IRON_ORE, quantity: 10 }] },
        ],
    },
    {
        type: QuestType.CRAFT_WEAPON,
        name: 'Craft a Weapon',
        description: 'Craft any weapon at a workstation',
        targetAmount: 1,
        icon: 'sword',
        prerequisites: [QuestType.CRAFT_AXE, QuestType.CRAFT_FISHING_ROD, QuestType.GATHER_FOOD],
        rewards: [
            {
                type: QuestRewardType.ITEMS,
                items: [
                    { itemType: ITEM_WOODEN_BOW, quantity: 1 },
                    { itemType: ITEM_WOODEN_ARROW, quantity: 20 },
                ],
            },
        ],
    },
    {
        type: QuestType.KILL_WOLF,
        name: 'Slay a Wolf',
        description: 'Kill a wolf in combat',
        targetAmount: 1,
        icon: 'wolf',
        prerequisites: [QuestType.CRAFT_WEAPON],
        rewards: [
            {
                type: QuestRewardType.ITEMS,
                items: [
                    { itemType: ITEM_IRON_SWORD, quantity: 1 },
                    { itemType: ITEM_IRON_BAR, quantity: 5 },
                ],
            },
        ],
    },
    {
        type: QuestType.BUILD_WALLS,
        name: 'Build Defenses',
        description: 'Build 4 walls for your base',
        targetAmount: 4,
        icon: 'wall',
        prerequisites: [QuestType.CRAFT_WEAPON],
        rewards: [{ type: QuestRewardType.SPAWN_PAWN }],
    },
];
// Get quest definition by type
export const getQuestDefinition = ({ type, }) => {
    return STARTER_QUESTS.find((quest) => quest.type === type);
};
// Get quests that are unlocked given a set of completed quest types
export const getUnlockedQuests = ({ completedTypes, }) => {
    return STARTER_QUESTS.filter((quest) => {
        // Skip already completed quests
        if (completedTypes.has(quest.type)) {
            return false;
        }
        // Check all prerequisites are completed
        return quest.prerequisites.every((prereq) => completedTypes.has(prereq));
    });
};
//# sourceMappingURL=types.js.map